import { createContext, useState } from 'react';
const AvailabilityContext = createContext();

const AvailabilityProvider = ({ children }) => {
  const [isAvailabilityOpen, setIsAvailabilityOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCoachId, setSelectedCoachId] = useState(null);
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [selectedCoachActivityId, setSelectedCoachActivityId] = useState(null);

  const openAvailability = (date, coachId, activityId, coachActivityId) => {
    setSelectedDate(date);
    setSelectedCoachId(coachId);
    setSelectedActivityId(activityId);
    setSelectedCoachActivityId(coachActivityId);
    setIsAvailabilityOpen(true);
  };

  const closeAvailability = () => {
    setIsAvailabilityOpen(false);
    setSelectedDate(null);
    setSelectedCoachId(null);
    setSelectedActivityId(null);
    setSelectedCoachActivityId(null);
  };

  return (
    <AvailabilityContext.Provider
      value={{
        isAvailabilityOpen,
        selectedDate,
        selectedCoachId,
        selectedActivityId,
        selectedCoachActivityId,
        openAvailability,
        closeAvailability
      }}
    >
      {children}
    </AvailabilityContext.Provider>
  );
};

export default AvailabilityProvider;
export { AvailabilityContext };
